import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import {CategoriaDocumento} from '../../../../model/class/CategoriaDocumento';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastsManager} from 'ng2-toastr';
import {Documento} from '../../../../model/class/Documento';
import {DocumentoService} from '../../../services/documento/documento.service';
import {FileUploader} from 'ng2-file-upload';
import {APP_CONTS} from '../../../app.constants';

@Component({
  selector: 'app-crear-ficha',
  templateUrl: './crear-ficha.component.html',
  styleUrls: ['./crear-ficha.component.css']
})
export class CrearFichaComponent implements OnInit {

  @Input() newDocumento: Documento;
  @Input() categorias: CategoriaDocumento[];
  editando = false;
  errorFileSize = false;

  dropZoneOver = {
    archivo: false
  };
  loaders = {
    form: false,
    archivo: false
  };

  fileFormat = APP_CONTS.FILES.DOC_FORMAT_STR;


  public uploader: FileUploader = new FileUploader({
    allowedMimeType:  APP_CONTS.FILES.DOC_FORMAT
  });

  constructor(
    public activeModal: NgbActiveModal,
    private toasts: ToastsManager,
    private documentoService: DocumentoService
  ) { }

  ngOnInit() {
    if (this.newDocumento.id) {
      this.editando = true;
    } else {
      this.newDocumento.publicada = true;
      if (this.categorias[0]) {
        this.newDocumento.categoriaDocumentoId = this.categorias[0].id;
      }
    }
  }

  fileOverBase(e: any): void {
    this.dropZoneOver.archivo = e;
  }

  cargarArchivo(event) {
    this.errorFileSize = false;
    if (this.uploader.queue[0]) {
      const file = this.uploader.queue[0]._file;
      if (file) {
        if (file.size / 1024000 <= APP_CONTS.FILES.MAX_FILE_SIZE_MB) {
          this.newDocumento.nuevaArchivo = file;
        } else {
          this.errorFileSize = true;
          delete this.newDocumento.nuevaArchivo;
        }
      }
    } else {
      console.log('Archivo no valido');
    }
    this.uploader.queue = [];
  }

  onSubmit() {
    this.loaders.form = true;
    if (this.editando) {
      this.documentoService.edit(this.newDocumento.id, this.newDocumento.getFormData())
        .subscribe(
          (data) => {
            this.loaders.form = false;
            this.toasts.success(`La Ficha a sido modificada exitosamente.`);
            this.activeModal.close(data.data);
          }, (error) => {
            this.loaders.form = false;
            this.toasts.error(`Ha ocurrido un error al modificar la Ficha.`);

          }
        );
    } else {

      const objFicha = new Documento(this.newDocumento);

      this.documentoService.create(objFicha.getFormData())
        .subscribe(
          (data) => {
            this.loaders.form = false;
            this.toasts.success(`La Ficha a sido creada exitosamente.`);
            this.activeModal.close(data.data);
          }, (error) => {
            this.loaders.form = false;
            this.toasts.error(`Ha ocurrido un error al crear la Ficha.`);
          }
        );
    }

  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/crear-ficha/crear-ficha.component.ts